/**
 * Theme Service
 *
 * Sets up the design token CSS variables for the support app.
 * Support app uses theme 'a' (green), dark mode only.
 */

import { Injectable, signal } from '@angular/core';
import colorsData from '../_datas/colors.json';

interface ColorsJson {
  data: {
    themes: Record<string, Record<string, Record<string, string>>>;
  };
}

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private colors = (colorsData as ColorsJson).data;

  // Support app uses theme 'a' (green), dark mode only
  private readonly theme = 'a';
  private readonly mode = 'Dark';

  // Signal to track if theme is initialized
  initialized = signal(false);

  constructor() {
    this.applyTheme();
  }

  applyTheme(): void {
    const themeColors = this.colors.themes[this.theme][this.mode];
    const root = document.documentElement;

    // Set all 38 color CSS variables
    for (let i = 1; i <= 38; i++) {
      const colorValue = themeColors[i.toString()];
      if (colorValue) {
        root.style.setProperty(`--color${i}`, colorValue);
      }
    }

    this.initialized.set(true);
  }
}
